import { Dispatch, SetStateAction } from 'react';

import Select, {
  DropdownIndicatorProps,
  PropsValue,
  components,
} from 'react-select';
import { DownCaretIcon } from '../assets/svgImages';
import { patientUserTypeList } from '../constant/constant';
import Loading from './Loading';
import useTemplateList from '../hooks/useTemplateLists';
import { FiltersState } from '../interface/interface';

const BulkEmailTemplateSelection = (props: {
  token: string | undefined;
  setValidTemplate: any;
  filters: FiltersState;
  setFilters: Dispatch<SetStateAction<FiltersState | undefined>>;
}) => {
  const [loading, list, handleSelection] = useTemplateList(
    props.token,
    props.setValidTemplate,
    props.filters,
    props.setFilters,
  );

  const DropdownIndicator = (props: DropdownIndicatorProps<true>) => {
    return (
      <components.DropdownIndicator {...props}>
        <DownCaretIcon />
      </components.DropdownIndicator>
    );
  };

  if (loading) return <Loading />;

  return (
    <div className="flex">
      <div className="mb-5">
        <label className="text-lg font-semibold  text-secondary-pink-700">
          Type<span className="text-red-500">*</span>
        </label>
        <Select
          className="w-72 cursor-pointer"
          value={
            props.filters?.userType?.value
              ? (props.filters?.userType as PropsValue<any>)
              : undefined
          }
          options={patientUserTypeList as any}
          onChange={(selected: any) =>
            props.setFilters({
              ...props.filters,
              userType: selected!,
            })
          }
          placeholder="Type"
          components={{
            DropdownIndicator,
            IndicatorSeparator: () => null,
          }}
        />
      </div>
      <div className="ms-5">
        <label className="text-lg font-semibold  text-secondary-pink-700">
          Template <span className="text-red-500">*</span>
        </label>
        <Select
          className="w-72 cursor-pointer"
          value={
            props.filters?.template?.value
              ? (props.filters?.template as PropsValue<any>)
              : undefined
          }
          options={list as any}
          onChange={async (selected: any) => {
            await handleSelection(selected);
          }}
          placeholder="Template"
          components={{
            DropdownIndicator,
            IndicatorSeparator: () => null,
          }}
        />
      </div>
    </div>
  );
};
export default BulkEmailTemplateSelection;
